export const productsData = [
    {
        id: 1,
        title: "SPINETHERA DTS TABLE",
        category: "TRACTION THERAPY",
        specs: [
            { label: "THERAPY TYPE:", value: "Spinal Decompression & Traction" },
            { label: "HEIGHT RANGE:", value: "59 cm – 110 cm Adjustable" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro1.png",
        description: "An advanced spinal decompression and traction therapy table designed to treat lumbar and cervical spine disorders.",
        keyFeatures: [
            "Traction Lock System for safe and controlled therapy ",
            "Adjustable Arm Rests for patient comfort ",
            "Gas Spring Support with Lockable Mechanism ",
            "Moving Wheels with Brake for easy movement ",
            "Strong and durable frame for continuous clinical use "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "211 cm" },
            { icon: "width", label: "Width", value: "77 cm" },
            { icon: "height", label: "Height Range", value: "59 – 110 cm" },
            { icon: "total_length", label: "Length with Stand", value: "275 cm" }
        ],
        catalogPage: 2,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/1Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/1Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/1Pro3.png",
            "https://primerehab.ascentbw.com/Image/Product/1Pro4.png",
             "https://primerehab.ascentbw.com/Image/Product/1Pro5.png"
        ]
    },
    {
        id: 2,
        title: "CHIROPRACTIC DROP TABLE",
        category: "CHIROPRACTIC EQUIPMENT",
        specs: [
            { label: "ADJUSTMENT:", value: "Multi-section drop mechanism" },
            { label: "HEIGHT CONTROL:", value: "52 – 90 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro2.png",
        description: "Designed for safe and precise spinal adjustments using a smooth drop mechanism.",
        keyFeatures: [
            "Multi-section drop mechanism for precise adjustments ",
            "Electric height control for therapist comfort ",
            "Adjustable drop tension (Customizable resistance) ",
            "90 mm high-density foam ",
            "Strong, stable frame for chiropractic thrust techniques "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "183 cm" },
            { icon: "width", label: "Width", value: "57 cm" },
            { icon: "height", label: "Height Range", value: "52 – 90 cm" }
        ],
        catalogPage: 3,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/2Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/2Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/2Pro3.JPG",
            "https://primerehab.ascentbw.com/Image/Product/2Pro4.png"
        ]
    },
    {
        id: 3,
        title: "UNWEIGHING SYSTEM",
        category: "GAIT TRAINING",
        specs: [
            { label: "LIFTING CAPACITY:", value: "200 kg" },
            { label: "SCALE CAPACITY:", value: "200 kg Integrated" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro3.png",
        description: "Used in rehabilitation to reduce body weight during gait training and exercise therapy.",
        keyFeatures: [
            "Motorized DC lifting mechanism for smooth movement ",
            "Hanging scale with digital weight display ",
            "Safety harness support for standing/gait training ",
            "SS pipe standing and walking hand support ",
            "Optional treadmill attachment for advanced rehab "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "150 cm" },
            { icon: "width", label: "Width", value: "112 cm" },
            { icon: "height", label: "Overall Height", value: "231 cm" }
        ],
        catalogPage: 4,
        gallery: []
    },
    {
        id: 4,
        title: "HIGH LOW TILTING TABLE",
        category: "REHABILITATION EQUIPMENT",
        specs: [
            { label: "TILTING ANGLE:", value: "+90°" },
            { label: "LIFTING CAPACITY:", value: "Up to 250 kg" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro4.png",
        description: "Used for safe patient positioning with height adjustment and tilting facility for gradual upright positioning.",
        keyFeatures: [
            "Motorized Hi-Low and Tilting System ",
            "Harness with Lockable Clips for secure positioning ",
            "Foot Leg Adjustment Board Angle +20° to -120° ",
            "Writing Board Support for patient activities ",
            "Moving Wheels with Brake for easy mobility "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "205 cm" },
            { icon: "width", label: "Width", value: "62 cm" },
            { icon: "height", label: "Height Range", value: "59 – 93 cm" }
        ],
        catalogPage: 5,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/4Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/4Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/4Pro3.png"
        ]
    },
    {
        id: 5,
        title: "HIGH LOW TRACTION TABLE",
        category: "TRACTION THERAPY",
        specs: [
            { label: "LIFTING CAPACITY:", value: "Up to 250 kg" },
            { label: "POWER SUPPLY:", value: "220V/50Hz" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro5.png",
        description: "Motorized table designed for effective cervical and lumbar traction therapy.",
        keyFeatures: [
            "Smooth electric height adjustment ",
            "Secure traction lock and adjustable backrest ",
            "Gas-spring assisted movements ",
            "Backrest Angle Up to +60° ",
            "Rexine Upholstery with Multiple Colour Options "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "195 cm" },
            { icon: "width", label: "Width", value: "73 cm" },
            { icon: "height", label: "Height Range", value: "54 – 101 cm" }
        ],
        catalogPage: 6,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/5Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/5Pro2.png"
        ]
    },
    {
        id: 6,
        title: "HIGH LOW BOBATH TABLE",
        category: "NEURO REHABILITATION",
        specs: [
            { label: "SURFACE:", value: "Wide Bobath Surface" },
            { label: "MAX LOAD:", value: "250 kg" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro6.png",
        description: "Designed for neuro rehabilitation and paediatric therapy with a wide, stable surface.",
        keyFeatures: [
            "Motorized Hi-Low Height Adjustment ",
            "Wide surface specifically for Bobath neuro therapy ",
            "Gas spring support with lockable mechanism ",
            "Lockable wheels for firm clinical use ",
            "Available in custom bed sizes "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "185 cm" },
            { icon: "width", label: "Width", value: "108 cm" },
            { icon: "height", label: "Height Range", value: "48 – 110 cm" }
        ],
        catalogPage: 7,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/6Pro1.png",
        ]
    },
    {
        id: 7,
        title: "HIGH LOW TWO FOLD TABLE",
        category: "PHYSIOTHERAPY & EXAMINATION",
        specs: [
            { label: "DESIGN:", value: "Two-section folding" },
            { label: "LIFTING CAPACITY:", value: "260 kg" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro7.png",
        description: "Motorized two-fold table designed for physiotherapy and examination use.",
        keyFeatures: [
            "Smooth electric height adjustment ",
            "Breathing Face Hole for patient comfort ",
            "Gas Spring Adjustable Backrest ",
            "Moving & Lockable Caster Wheels ",
            "Multiple rexine colour options "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "188 cm" },
            { icon: "width", label: "Width", value: "70 cm" },
            { icon: "height", label: "Height Range", value: "54 – 101 cm" }
        ],
        catalogPage: 8,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/7Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/7Pro2.png"
        ]
    },
    {
        id: 8,
        title: "HIGH LOW 3-FOLD TABLE",
        category: "PHYSIOTHERAPY & REHABILITATION",
        specs: [
            { label: "DESIGN:", value: "Three-section folding" },
            { label: "LIFTING CAPACITY:", value: "260 kg" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro8.png",
        description: "Three-section folding design allows flexible patient positioning and therapist comfort.",
        keyFeatures: [
            "Motorized Hi-Low Operation with Remote Control ",
            "Adjustable Backrest and Leg Rest ",
            "Breathing Face Hole for patient comfort ",
            "2.5-inch High-Density Foam Padding ",
            "4 Moving Wheels with Lockable Brakes "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "180 cm" },
            { icon: "width", label: "Width", value: "70 cm" },
            { icon: "height", label: "Height Range", value: "54 – 102 cm" }
        ],
        catalogPage: 9,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/8Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/8Pro2.png"
        ]
    },
    {
        id: 9,
        title: "FIXED HEIGHT TILTING TABLE",
        category: "REHABILITATION EQUIPMENT",
        specs: [
            { label: "HEIGHT:", value: "Fixed 75 cm" },
            { label: "TILTING ANGLE:", value: "0° to 90°" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro9.png",
        description: "Fixed height tilting table designed for routine therapy and rehab procedures.",
        keyFeatures: [
            "Motorized tilting with remote control ",
            "Adjustable backrest and leg rest ",
            "Safety harness support provided ",
            "Non-slip foot step with grip mat ",
            "Moving caster wheels with lock for safety "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "201 cm" },
            { icon: "width", label: "Width", value: "62 cm" },
            { icon: "footstep", label: "Foot Step Size", value: "46 x 36 cm" }
        ],
        catalogPage: 10,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/9Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/9Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/9Pro3.png"
        ]
    },
    {
        id: 10,
        title: "TRACTION TABLE",
        category: "ORTHOPAEDIC THERAPY",
        specs: [
            { label: "FRAME TYPE:", value: "Heavy-duty MS Powder Coated" },
            { label: "MAX LOAD:", value: "200 kg" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro10.png",
        description: "Designed for cervical and lumbar therapy with smooth moving traction bed mechanism.",
        keyFeatures: [
            "Heavy-duty MS frame with powder coating ",
            "Comfortable cushioning with rexine upholstery ",
            "Stable and durable design for traction therapy ",
            "Rexine colour options available ",
            "Flexion stool - optional "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "185 cm" },
            { icon: "width", label: "Width", value: "62 cm" },
            { icon: "height", label: "Height", value: "72 cm" }
        ],
        catalogPage: 11,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/10Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/10Pro2.png"
        ]
    },
    {
        id: 11,
        title: "TRACTION 4-FOLD TABLE",
        category: "TRACTION THERAPY",
        specs: [
            { label: "DESIGN:", value: "4-fold traction design" },
            { label: "MAX LOAD:", value: "200 kg" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro11.png",
        description: "Provides smooth and controlled traction with adjustable sections for cervical and lumbar traction.",
        keyFeatures: [
            "4-fold table for versatile therapy ",
            "Backrest angle adjustment up to +60° ",
            "Leg rest angle adjustment down to -60° ",
            "Smoothly moving traction bed mechanism ",
            "Strong, stable construction for clinical use "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "187 cm" },
            { icon: "width", label: "Width", value: "62 cm" },
            { icon: "height", label: "Height", value: "76 cm" }
        ],
        catalogPage: 12,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/11Pro1.png"
        ]
    },
    {
        id: 12,
        title: "TREATMENT COUCH 3-FOLD",
        category: "CLINICAL FURNITURE",
        specs: [
            { label: "BACKREST:", value: "Adjustable up to 65°" },
            { label: "FACE ANGLE:", value: "Downward up to -50°" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro12.png",
        description: "Features adjustable backrest and leg rest for versatile patient positioning during treatment.",
        keyFeatures: [
            "3-fold design for physiotherapy and clinical use ",
            "Two-section backrest with breathing face hole ",
            "Comfortable padding with rexine upholstery ",
            "Rexine colour options available ",
            "Strong and stable construction for daily use "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "205 cm" },
            { icon: "width", label: "Width", value: "70 cm" },
            { icon: "height", label: "Height", value: "81 cm" }
        ],
        catalogPage: 13,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/12Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/12Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/12Pro3.png",
        ]
    },
    {
        id: 13,
        title: "PLAIN TREATMENT TABLE",
        category: "CLINICAL FURNITURE",
        specs: [
            { label: "FRAME:", value: "Durable MS Powder Coated" },
            { label: "UPHOLSTERY:", value: "Premium quality rexine" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro13.png",
        description: "Plain treatment table built with a strong, stable frame and comfortable cushioning.",
        keyFeatures: [
            "Durable MS frame with powder-coated finish ",
            "Multiple standard sizes available ",
            "Easy to clean and maintain surface ",
            "Custom size available as per requirement ",
            "Multiple rexine colour options "
        ],
        detailedSpecs: [
            { icon: "material", label: "Frame Material", value: "Mild Steel (MS)" }
        ],
        catalogPage: 14,
        gallery: []
    },
    {
        id: 14,
        title: "SUSPENSION TABLE WITH ACCESSORIES",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "HEIGHT:", value: "192 cm" },
            { label: "BACKREST ANGLE:", value: "Up to 60°" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro14.png",
        description: "Comes with complete accessories for upper and lower limb suspension therapy exercises.",
        keyFeatures: [
            "Suspension table with complete accessories ",
            "Strong, stable suspension frame construction ",
            "Smooth movement ensures safe exercise performance ",
            "Spider Cage and Top Selling Cage models available ",
            "Comfortable padding with rexine upholstery "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "188 cm" },
            { icon: "width", label: "Width", value: "83 cm" },
            { icon: "height", label: "Height", value: "192 cm" }
        ],
        catalogPage: 15,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/14Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/14Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/14Pro3.png"
        ]
    },
    {
        id: 15,
        title: "PARALLEL BAR WITH PLATFORM",
        category: "GAIT TRAINING",
        specs: [
            { label: "OVERALL SIZE:", value: "10 ft x 3 ft" },
            { label: "HEIGHT RANGE:", value: "75 cm to 125 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro15.png",
        description: "Designed for gait training and neurological therapy with stable hand support.",
        keyFeatures: [
            "High-quality carpet mat for walking pathway ",
            "Adjustable height mechanism ",
            "Strong and stable construction ",
            "Models with/without platform or SS platform ",
            "Mirror - Optional "
        ],
        detailedSpecs: [
            { icon: "dim", label: "Size (cm)", value: "305 x 96 x 75" }
        ],
        catalogPage: 16,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/15Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/15Pro2.png"
        ]
    },
    {
        id: 16,
        title: "STAIRCASE WITH RAMP TYPE",
        category: "GAIT TRAINING",
        specs: [
            { label: "RAMP LENGTH:", value: "224 cm" },
            { label: "OVERALL HEIGHT:", value: "58 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro16.png",
        description: "Used for gait, balance, and mobility exercises to practice stair climbing and ramp walking.",
        keyFeatures: [
            "Strong wooden and steel construction ",
            "Sturdy handrails for patient support ",
            "Smooth ramp surface for safe movement ",
            "Anti-slip steps for user safety ",
            "Four model variations including Corner Staircases "
        ],
        detailedSpecs: [
            { icon: "step_length", label: "L-Step Length", value: "180 cm" }
        ],
        catalogPage: 17,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/16Pro1.png"
        ]
    },
    {
        id: 17,
        title: "STANDING FRAME",
        category: "REHABILITATION EQUIPMENT",
        specs: [
            { label: "LOAD CAPACITY:", value: "Up to 500 kg" },
            { label: "HEIGHT ADJ:", value: "99 cm to 147 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro17.png",
        description: "Rehabilitation equipment used to support patients in standing position safely.",
        keyFeatures: [
            "Heavy-duty MS frame with stable base ",
            "Height adjustable vertical support ",
            "Belt support with rope for secure standing ",
            "High load-bearing capacity up to 500 kg ",
            "Designed for long-term clinical use "
        ],
        detailedSpecs: [
            { icon: "dim", label: "Base Size", value: "122 x 76 x 96 cm" }
        ],
        catalogPage: 18,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/17Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/17Pro2.png"
        ]
    },
    {
        id: 18,
        title: "QUADRICEPS CHAIR",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "BACKREST ANGLE:", value: "Up to +80°" },
            { label: "WEIGHT SET:", value: "Included (1kg & 2kg)" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro18.png",
        description: "Specially designed for strengthening the quadriceps muscles and controlled knee extension.",
        keyFeatures: [
            "Chrome plated lever set for smooth operation ",
            "Backrest with gas spring support and lockable system ",
            "Rubber padded arm rests and grip handles ",
            "Includes weight set: 1 kg x 1, 2 kg x 2 ",
            "Optional single or double lever set "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "55 cm" },
            { icon: "width", label: "Width", value: "57 cm" },
            { icon: "height", label: "Height", value: "70 cm" }
        ],
        catalogPage: 19,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/18Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/18Pro2.png",
            "https://primerehab.ascentbw.com/Image/Product/18Pro3.png"
        ]
    },
    {
        id: 19,
        title: "FLEXION STOOL",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "USE:", value: "Spinal flexion exercises" },
            { label: "SUPPORT:", value: "Stable physiotherapy stool" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro19.png",
        description: "Support stool designed to assist patients during lumbar and spinal flexion exercises.",
        keyFeatures: [
            "Helps reduce strain during treatment ",
            "Improves patient posture during exercises ",
            "Provides stable clinical support ",
            "Ideal for physiotherapy clinics "
        ],
        catalogPage: 20,
        gallery: [
        ]
    },
    {
        id: 20,
        title: "SHOULDER WHEEL",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "ROTATION:", value: "360° Smooth movement" },
            { label: "WHEEL DIAMETER:", value: "76 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro20.png",
        description: "Rehabilitation exercise device used to improve shoulder joint mobility and range of motion.",
        keyFeatures: [
            "360° smooth rotational movement ",
            "Heavy-duty MS construction ",
            "Powder-coated finish for corrosion resistance ",
            "Adjustable friction for controlled resistance ",
            "Ideal for range-of-motion exercises "
        ],
        catalogPage:20,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/20Pro1.png"
        ]
    },
    {
        id: 21,
        title: "MIRROR STAND",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "DIMENSIONS:", value: "90 x 53 x 130 cm" },
            { label: "MIRROR:", value: "Full-length clear feedback" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro21.png",
        description: "Used for posture correction and exercise monitoring with accurate visual feedback.",
        keyFeatures: [
            "Strong MS frame with powder-coated finish ",
            "Smooth caster wheels for easy movement ",
            "Stable base design for safe usage ",
            "Easy to clean and maintain smooth finish ",
            "Mirror customization available "
        ],
        catalogPage: 21,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/21Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/21Pro2.png"
        ]
    },
    {
        id: 22,
        title: "Z TROLLEY",
        category: "CLINICAL FURNITURE",
        specs: [
            { label: "TRAYS:", value: "3 Organized storage trays" },
            { label: "DIMENSIONS:", value: "50 x 52 x 90 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro22.png",
        description: "Compact medical trolley featuring a space-saving Z-shape design for clinics.",
        keyFeatures: [
            "Strong MS powder-coated frame ",
            "3 trays for organized storage ",
            "Smooth caster wheels with brake ",
            "Stable structure for daily clinical use ",
            "Tray size: 50 x 37 cm "
        ],
        catalogPage: 22,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/22Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/22Pro2.png"
        ]
    },
    {
        id: 23,
        title: "ACRYLIC BOX TROLLEY",
        category: "CLINICAL FURNITURE",
        specs: [
            { label: "TRAY SIZE:", value: "48 x 47 cm" },
            { label: "DIMENSIONS:", value: "50 x 40 x 95 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro23.png",
        description: "Hygienic storage trolley with transparent acrylic sheet trays for easy visibility.",
        keyFeatures: [
            "Strong MS box with powder-coated finish ",
            "Lockable storage for safety and organization ",
            "Smooth 3-inch moving caster wheels with brake ",
            "Hygienic and easy to clean ",
            "Suitable for medical and therapy use "
        ],
        catalogPage: 23,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/23Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/23Pro2.png"
        ]
    },
    {
        id: 24,
        title: "TWO TRAY TROLLEY",
        category: "CLINICAL FURNITURE",
        specs: [
            { label: "HEIGHT:", value: "105 cm" },
            { label: "TRAY SIZE:", value: "43 x 43 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro24.png",
        description: "Compact medical trolley with two spacious trays and electrical equipment provision.",
        keyFeatures: [
            "Two spacious trays for storage ",
            "Mains cable provision with pillar connection ",
            "Smooth caster wheels with brake ",
            "Detachable design for easy shipping ",
            "Strong and stable construction "
        ],
        detailedSpecs: [
            { icon: "length", label: "Length", value: "53 cm" },
            { icon: "width", label: "Width", value: "48 cm" }
        ],
        catalogPage: 24,
        gallery: []
    },
    {
        id: 25,
        title: "SUPINATOR PRONATOR",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "ROTATION:", value: "360° Smooth rotation" },
            { label: "CONSTRUCTION:", value: "Strong SS pipe" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro25.png",
        description: "Designed to improve forearm rotation, wrist mobility, and muscle strength.",
        keyFeatures: [
            "360° smooth rotation for full movement ",
            "Height adjustable fixing system ",
            "Rotation diameter adjustable ",
            "Friction control for resistance training ",
            "Strong SS pipe construction with wooden handle "
        ],
        catalogPage: 25,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/25Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/25Pro2.png"
        ]
    },
    {
        id: 26,
        title: "FINGER LADDER",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "STEPS:", value: "26 Numbered steps" },
            { label: "MATERIAL:", value: "High-quality teak wood" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro26.png",
        description: "Tool used to improve shoulder and arm range of motion through elevation.",
        keyFeatures: [
            "26 numbered steps with clear stickers ",
            "Made from high-quality teak wood ",
            "Smooth finish for safe finger movement ",
            "Encourages gradual, pain-free elevation ",
            "Ideal for post-surgical rehabilitation "
        ],
        detailedSpecs: [
            { icon: "height", label: "Overall Height", value: "115 cm" }
        ],
        catalogPage: 26,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/26Pro1.png"
        ]
    },
    {
        id: 27,
        title: "ANKLE EXERCISE DEVICE",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "RESISTANCE:", value: "Adjustable spring-loaded" },
            { label: "SAFETY:", value: "Foot lockable belts" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro27.png",
        description: "Used to improve joint range of motion and muscle flexibility through angular movement.",
        keyFeatures: [
            "Spring load adjustable for progressive resistance ",
            "Foot lockable belts for secure exercise ",
            "Sturdy and durable construction ",
            "Helps improve ankle strength and mobility ",
            "Suitable for clinic and home therapy "
        ],
        catalogPage: 26,
        gallery: [
        ]
    },
    {
        id: 28,
        title: "OVERHEAD PULLEY",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "MOUNTING:", value: "Wall mounting" },
            { label: "PULLEY:", value: "Smooth pulley mechanism" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro28.png",
        description: "Supports assisted and active exercises to improve shoulder mobility.",
        keyFeatures: [
            "Space-saving wall mounting design ",
            "Adjustable height as per installation ",
            "Smooth pulley mechanism ",
            "Supports shoulder movement therapy ",
            "Easy to install and maintain "
        ],
        catalogPage: 27,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/28Pro1.png"
        ]
    },
    {
        id: 29,
        title: "BALANCE BOARD",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "LOAD CAPACITY:", value: "Up to 300 Kg" },
            { label: "DIMENSIONS:", value: "46 x 36 x 11 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro29.png",
        description: "Used to improve balance, coordination, and ankle stability.",
        keyFeatures: [
            "Anti-slip surface for secure footing ",
            "Strong and durable construction ",
            "300 kg load capacity for safe training ",
            "Helps strengthen lower limb muscles ",
            "Suitable for neurological rehabilitation "
        ],
        catalogPage: 27,
        gallery: [
        ]
    },
    {
        id: 30,
        title: "WOBBLE BOARD",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "TILTING ANGLE:", value: "15° controlled instability" },
            { label: "ROTATION:", value: "360° multidirectional" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro30.png",
        description: "Used to improve balance and proprioception through multidirectional rotation.",
        keyFeatures: [
            "360° rotation for balance training ",
            "15° tilting angle for instability exercises ",
            "Helps strengthen ankle, knee, and core ",
            "Ideal for neurological rehabilitation ",
            "Ring Diameter (OD): 18 Inch "
        ],
        catalogPage: 28,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/30Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/30Pro2.png"
        ]
    },
    {
        id: 31,
        title: "FOOT STOOL SINGLE & DOUBLE",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "SINGLE SIZE:", value: "460 x 300 x 190 mm" },
            { label: "DOUBLE SIZE:", value: "600 x 460 x 310 mm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro31.png",
        description: "Sturdy support accessory to assist patients during exercises and movement.",
        keyFeatures: [
            "Strong and durable construction ",
            "High 300 kg load capacity ",
            "Anti-slip surface for secure footing ",
            "Double stool offers two-step height ",
            "Ideal for clinic use "
        ],
        catalogPage: 28,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/31Pro1.png"
        ]
    },
    {
        id: 32,
        title: "DUMBBELLS STAND",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "USE:", value: "Organized storage" },
            { label: "CONSTRUCTION:", value: "Durable for daily use" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro32.png",
        description: "Compact and sturdy stand designed for organized storage of dumbbells in clinics.",
        keyFeatures: [
            "Keeps weights easily accessible ",
            "Improves safety by organizing workout area ",
            "Strong construction for clinical use ",
            "Maintains a neat workout area ",
            "Designed for space-efficient storage "
        ],
        catalogPage:29,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/32Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/32Pro2.png"
        ]
    },
    {
        id: 33,
        title: "RE-EDUCATION BOARD",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "MAX HEIGHT:", value: "35 cm" },
            { label: "BOARD ANGLE:", value: "20°" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro33.png",
        description: "Used for neuromuscular re-education, postural control, and ankle stability.",
        keyFeatures: [
            "Designed for coordination and proprioception ",
            "Adjustable height for progressive therapy ",
            "Stable and sturdy for safe clinical use ",
            "Helps in coordination training ",
            "Size (cm): 61 x 61 x 35 "
        ],
        catalogPage: 29,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/33Pro1.png",
            "https://primerehab.ascentbw.com/Image/Product/33Pro2.png"
        ]
    },
    {
        id: 34,
        title: "BOLSTER",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "MATERIAL:", value: "High-density foam" },
            { label: "COVER:", value: "Durable washable cover" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro34.png",
        description: "Cylindrical foam support used for patient positioning, posture correction, and comfort.",
        keyFeatures: [
            "Helps in rehabilitation and relaxation therapy ",
            "Provides back and neck support ",
            "High-density foam for patient comfort ",
            "Durable and washable cover ",
            "Multiple standard diameter sizes available "
        ],
        catalogPage: 30,
        gallery: [
        ]
    },
    {
        id: 35,
        title: "WEDGES",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "UPHOLSTERY:", value: "Easy-to-clean rexine" },
            { label: "FOAM:", value: "Firm, high-density" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro35.png",
        description: "Used for positioning and support to maintain proper body alignment during treatment.",
        keyFeatures: [
            "Firm foam for stable support ",
            "Durable, easy-to-clean rexine upholstery ",
            "Assists in treatment procedures ",
            "Multiple colour options available ",
            "Size: 24 x 30 x 12 inch "
        ],
        catalogPage: 30,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/35Pro1.png"
        ]
    },
    {
        id: 36,
        title: "C TABLE SMALL SIZE",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "DIMENSIONS:", value: "53 x 61 x 40 cm" },
            { label: "DESIGN:", value: "C-shaped compact" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro36.png",
        description: "Compact and sturdy support table ideal for limb support and patient positioning.",
        keyFeatures: [
            "C-shaped for easy positioning near tables ",
            "ARC wooden boards for training support ",
            "Strong, stable construction ",
            "Suitable for upper/lower limb rehabilitation ",
            "Ideal for rehabilitation centers "
        ],
        catalogPage: 31,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/36Pro1.png"
        ]
    },
    {
        id: 37,
        title: "C TABLE BIG SIZE",
        category: "PHYSIOTHERAPY AIDS",
        specs: [
            { label: "HEIGHT RANGE:", value: "75 cm to 125 cm" },
            { label: "DIMENSIONS:", value: "185 x 85 x 75 cm" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro37.png",
        description: "Large C-shaped support table designed for versatile physiotherapy and rehabilitation.",
        keyFeatures: [
            "Height adjustable for therapy needs ",
            "Stable support for limb exercises ",
            "Strong, stable frame construction ",
            "Easy to position around patients ",
            "Suitable for ARC board training "
        ],
        catalogPage: 31,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/37Pro1.png"
        ]
    },
    {
        id: 38,
        title: "ADL KITCHEN",
        category: "ACTIVITIES OF DAILY LIVING",
        specs: [
            { label: "MODULAR:", value: "Flexible layout" },
            { label: "CUSTOMIZABLE:", value: "Per clinic plan" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro38.png",
        description: "Therapeutic kitchen setup designed for Activities of Daily Living (ADL) training.",
        keyFeatures: [
            "Functional tasks like cooking and utensils ",
            "Supports coma stimulation programs ",
            "Enhances patient independence and confidence ",
            "Types: Kitchen, Bedroom, Bathroom ADL ",
            "Speech therapy and cognitive rehabilitation "
        ],
        catalogPage: 32,
        gallery: [
            "https://primerehab.ascentbw.com/Image/Product/38Pro1.JPG",
            "https://primerehab.ascentbw.com/Image/Product/38Pro2.JPG",
            "https://primerehab.ascentbw.com/Image/Product/38Pro3.JPG",
            "https://primerehab.ascentbw.com/Image/Product/38Pro4.JPG",
            "https://primerehab.ascentbw.com/Image/Product/38Pro5.png"
        ]
    },
    {
        id: 39,
        title: "SUSPENSION SPIDER CAGE THERAPY",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "DIMENSIONS:", value: "6 x 6 x 7 Feet" },
            { label: "FRAME:", value: "Strong MS construction" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro39.png",
        description: "Used to support body weight during suspension therapy exercises to improve strength.",
        keyFeatures: [
            "Stable suspension points for exercises ",
            "Improves balance and joint mobility safely ",
            "Strong MS frame construction ",
            "Designed for clinical suspension therapy ",
            "Spacious cage design for safety "
        ],
        catalogPage: 33,
        gallery: [
        ]
    },
    {
        id: 40,
        title: "MS WALL LADDER",
        category: "EXERCISE THERAPY",
        specs: [
            { label: "WIDTH:", value: "2.5 Feet" },
            { label: "HEIGHT:", value: "7 Feet" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro40.png",
        description: "Heavy-duty wall-mounted ladder for stretching, strengthening, and mobility training.",
        keyFeatures: [
            "Strong mild steel frame ",
            "Powder-coated finish for durability ",
            "Safe support for clinic rehabilitation ",
            "Wall-mounted for stability ",
            "Ideal for stretching and strengthening "
        ],
        catalogPage: 33,
        gallery: [
        ]
    },
    {
        id: 41,
        title: "MULTI WORKING STATION",
        category: "OCCUPATIONAL THERAPY",
        specs: [
            { label: "SIZE:", value: "30 x 30 x 30 Inches" },
            { label: "MODULES:", value: "Lock, Peg, Nut boards" }
        ],
        image: "https://primerehab.ascentbw.com/Image/Product/Pro41.png",
        description: "Versatile working station for functional training and motor skills.",
        keyFeatures: [
            "ADL Lock Board (locks, latches, chains) ",
            "Peg Board / Finger Dexterity Board ",
            "Bolt & Nut Board / Grip Training ",
            "Shape Sorter and Puzzle Boards ",
            "Hand Function Training Toys "
        ],
        catalogPage: 34,
        gallery: [
        ]
    }
];

export const getAllProducts = () => {
    return productsData;
};

export const allProductsData = getAllProducts();